import React from "react";
import Calculator from "../../shared/Calculator";
import appStore from "../../../assets/images/app-store.png";
import googlePlay from "../../../assets/images/google-play.png";
import QRCode from "../../../assets/images/scan.png";
import Banner from "../../../assets/images/hero-banner.png";
import Banner2 from "../../../assets/images/hero-banner-2.png";
import Banner3 from "../../../assets/images/hero-banner-3.png";

import { Carousel } from "react-bootstrap";
const HeroSection = () => {
  return (
    <>
      <div className="d-lg-flex d-none align-items-center hero-section">
        <Carousel className="h-100 w-100" controls={false}>
          <Carousel.Item>
            <img className="d-block w-100" src={Banner3} alt="First slide" />
          </Carousel.Item>
          <Carousel.Item>
            <img className="d-block w-100" src={Banner2} alt="Second slide" />
          </Carousel.Item>
          <Carousel.Item>
            <img className="d-block w-100" src={Banner} alt="Third slide" />
          </Carousel.Item>
        </Carousel>
        <div className="h-100 w-100 position-absolute  py-4 px-lg-3">
          <div className="row w-100 m-0 h-100 justify-content-center align-items-center px-lg-3 ">
            <div className="col-xl-4 col-lg-8 text-white text-lg-left text-center">
              <h1 className="font-weight-bold bg-secondary hero-title">
                THE CHEAPEST & FASTEST WAY TO SEND MONEY GLOBALLY
              </h1>
              <div className="d-none d-lg-block">
                <img className="qr-code" src={QRCode} height={100} />
              </div>
              <div className="store mt-3">
                <img
                  src={appStore}
                  alt=""
                  height="50"
                  className="mr-2 mb-2 cursor-pointer app-store-img"
                  onClick={() =>
                    window.open(
                      "https://apps.apple.com/ng/app/ileero-remit/id1566849731",
                      "_blank"
                    )
                  }
                />
                <img
                  src={googlePlay}
                  alt=""
                  height="50"
                  className=" mb-2 cursor-pointer google-play-img"
                  onClick={() =>
                    window.open(
                      "https://play.google.com/store/apps/details?id=com.ileero.remit",
                      "_blank"
                    )
                  }
                />
              </div>
            </div>
            <div className="offset-xl-2 mt-5 mt-xl-0 col-lg-8 col-xl-4 d-xl-flex justify-content-center align-items-center">
              <div>
                <Calculator />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="d-flex  flex-column align-items-center justify-content-center vh-100 d-lg-none bg-white p-4 py-5">
        <h1 className="font-weight-bold text-primary my-4">
          THE CHEAPEST WAY TO SEND MONEY TO AFRICA & ASIA
        </h1>
        <p className="text-primary mb-5">
          Securely transfer money accross borders to friends and family into
          their accounts in any bank or mobile wallets anytime with ease.
        </p>
        <Calculator />
        <div className="store mt-3 text-center">
          <img
            src={appStore}
            alt=""
            height="40"
            className="mb-2 mr-2 cursor-pointer app-store-img"
            onClick={() =>
              window.open(
                "https://apps.apple.com/ng/app/ileero-remit/id1566849731",
                "_blank"
              )
            }
          />
          <img
            src={googlePlay}
            alt=""
            height="40"
            className=" mb-2 cursor-pointer google-play-img"
            onClick={() =>
              window.open(
                "https://play.google.com/store/apps/details?id=com.ileero.remit",
                "_blank"
              )
            }
          />
        </div>
      </div>
    </>
  );
};

export default HeroSection;
